const http = require('../lib/httpClient');
const { OTP, COMMERCE_HEADER, SESSION_STORAGE } = require('../constants');
const {
  getChannelId,
  getEcommId,
  getXCommerceValue,
  getItemInSessionStorage,
} = require('../lib/browserData');

const catalystOtpByError = {
  code: 'CATALYST_GET_OTP_BY_CHALLENGE_ERROR',
  message: 'Unable to get otp by challenge',
};

const endpoint = '/s/auth/v1/otp/challenge';
const operationType = OTP.OPERATION_TYPE.OTP_NEW_REGISTERED_DEVICE;

async function catalystOtpByChallenge(
  tenantId,
  catalystBaseUrl = '',
  isEmailFlow = false,
  otpFlow = false,
) {
  const challengeType = isEmailFlow ? 'email' : 'sms';
  const isDeviceRecognised = getItemInSessionStorage(SESSION_STORAGE.IS_DEVICE_RECOGNISED);
  const fAuthDeviceId = getItemInSessionStorage(SESSION_STORAGE.F_AUTH_DEVICE_ID);
  const userData = JSON.parse(getItemInSessionStorage(SESSION_STORAGE.USER_DATA));

  const { sessionId } = userData;

  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { operationType, challengeType },
    {
      otpFlow,
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId),
        authorization: sessionId,
        'x-f-auth-device-recognized': isDeviceRecognised,
        'x-f-auth-device-id': fAuthDeviceId,
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );
  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystOtpByError] };
  const { success, challengeId, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  if (!success) {
    return {
      data: { success, challengeId },
      errors: [catalystOtpByError],
    };
  }
  return { data: { success, challengeId }, errors: [] };
}

module.exports = catalystOtpByChallenge;
